import React from "react";
//hooks
import { useBreadCrumbs } from "./BreadCrumbs.hooks";

//interfaces
import { IBreadCrumb } from "@/interfaces/IBreadCrumbs";

//helpers
import { buildBreadCrumbUrl } from "@/helpers/BreadCrumbs";

//styling
import "../../../css/breadcrumbs/breadcrumbs.scss";




const BreadCrumbs = ({menuId}:{menuId?: string}) => {
    const { breadCrumbs } = useBreadCrumbs(menuId);

    if (!breadCrumbs.length || breadCrumbs.length === 1 ) return null;

    return (
        <div id="breadcrumbs-container">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    {breadCrumbs.map((crumb: IBreadCrumb, index: number) => {
                        const url = buildBreadCrumbUrl(crumb);
                        const isLast = index === breadCrumbs.length - 1;

                        return (
                            <li key={index} className="breadcrumb-item">
                                {isLast 
                                    ?   (<span aria-current="page">{crumb.label}</span>)
                                    :   (<>
                                        <a
                                            href={url}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.location.href = url;
                                            }}
                                        >
                                            {crumb.label}
                                        </a>

                                        <span className="chevron"> › </span>
                                        </>)
                                }
                            </li>
                        );
                    })}
                </ol>
            </nav>
        </div>
    );
};

export default BreadCrumbs;